export const toggleAppointmentRequestsModalClass = ({ action }) => {
  const modal = document.querySelector('.pet-appointment-requests-modal');

  if (modal) {
    action === 'add'
      ? modal.classList.add('hidden')
      : modal.classList.remove('hidden');
  }
};
